// Mirror of the server's aurora_cloud/agreement.py. The pinned SHA-256 in
// agreement.parity.test.ts guards byte-parity; if you change a character
// here, change it there too and bump AGREEMENT_VERSION on both sides.

export const AGREEMENT_VERSION = "cloud-v1";

export const AGREEMENT_POINTS: { title: string; body: string }[] = [
  {
    title: "What this is.",
    body:
      "Aurora reads the messages you upload and produces a written analysis. " +
      "It groups what it finds into patterns, and cites each one to the " +
      "specific messages it's based on.",
  },
  {
    title: "Not legal advice, not a diagnosis.",
    body:
      "This analysis is a reading of your messages. It is not legal advice, " +
      "and it does not diagnose anyone with anything. Take it to a lawyer or " +
      "a self-help center to decide what to do with it.",
  },
  {
    title: "What it can and can't do.",
    body:
      "Aurora works only from the record you give it. It will not invent " +
      "patterns that aren't there — and it also will not necessarily find " +
      "every pattern that is. If it doesn't surface something, that is not " +
      "proof the something isn't real.",
  },
  {
    title: "The records are yours to share.",
    body:
      "You confirm the messages you're uploading are your own, or that you " +
      "otherwise have the right to share them.",
  },
  {
    title: "How your messages are handled.",
    body:
      "Your file is read in your browser, then sent to Anthropic's Claude to " +
      "run the analysis. Your messages are deleted from our servers the " +
      "moment your result is ready. Your finished analysis is an encrypted " +
      "file only you can open; it stays available to download for 7 days, " +
      "then it's deleted too.",
  },
];

// Deterministic canonical rendering — MUST reproduce the server's byte layout
// exactly (aurora_cloud/agreement.py AGREEMENT_TEXT). Format: "N. Title Body",
// points joined by a blank line.
export const AGREEMENT_TEXT = AGREEMENT_POINTS.map(
  (p, i) => `${i + 1}. ${p.title} ${p.body}`,
).join("\n\n");
